export default "__VITE_ASSET__D_AK4u0Z__"